const Clone = function () {
  return JSON.parse(JSON.stringify.apply(this, arguments))
}

const isObject = function (val) {
  return Object.prototype.toString.call(val) === '[object Object]'
}

function PartialUpdate(out) {
  out = out || {}
  let strict = typeof arguments[arguments.length - 1] === 'boolean' && arguments[arguments.length - 1]

  const canWrite = (key, target, value) => {
    if (!strict) return true
    if (!(key in target)) return false
    if (isObject(target[key]) && [null, undefined].includes(value[key])) return false

    return true
  }

  for (var i = 1, len = arguments.length; i < len; ++i) {
    var obj = arguments[i]

    if (!obj) {
      continue
    }

    for (var key in obj) {
      if (!obj.hasOwnProperty(key)) {
        continue
      }

      if (out[key] && isObject(obj[key])) {
        if (canWrite(key, out, obj)) out[key] = PartialUpdate(out[key], obj[key], strict)
        continue
      }

      if (canWrite(key, out, obj)) out[key] = obj[key]
    }
  }

  return out
}

function IconBinding(value) {
  if (!value) return
  if (value instanceof Array || typeof value === 'string') return { icon: value }
  return value
}

function setByPath(path, value, obj) {
  if (!obj) return

  let getValue = (v, s) => {
    if (typeof v === 'function') return v(s)
    return v
  }

  if (typeof path === 'string') path = path.split('.')
  let current = path.shift()

  // Handle wildcards
  if (path[0] === '*' && obj[current] instanceof Array) {
    path = path.slice(1) // Remove wildcard from path
    if (!path.length) return obj[current].map(entry => getValue(value, entry))

    return obj[current].map(entry => setByPath([...path], value, entry))
  }

  if (path.length) return setByPath(path, value, obj[current])
  return (obj[current] = getValue(value, obj[current]))
}

function getByPath(path, obj) {
  if (typeof path === 'string') path = path.split('.')
  let current = path.shift()

  return path.length ? getByPath(path, obj[current]) : obj[current]
}

function Debounce(func, wait, immediate) {
  let timeout
  return function () {
    let context = this,
      args = arguments
    let later = function () {
      timeout = null
      if (!immediate) func.apply(context, args)
    }
    let callNow = immediate && !timeout
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
    if (callNow) func.apply(context, args)
  }
}

function getDimensions(url) {
  return new Promise((resolve, reject) => {
    if (!url) return reject(new Error('Url is required'))
    let img = new Image()
    img.onload = function () {
      resolve({
        width: img.width,
        height: img.height,
      })
    }
    img.onerror = reject
    img.src = url
  })
}

function getCookie(cname) {
  var name = cname + '='
  var decodedCookie = decodeURIComponent(document.cookie)
  var ca = decodedCookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) == ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

function Capitalize(val = '') {
  return val.charAt(0).toUpperCase() + val.substring(1)
}

function Initials(val = '') {
  return val
    .split(' ')
    .map(p => p.substring(0, 1))
    .join('')
}

function MakeArray(val) {
  if ([undefined, null].includes(val)) return []
  return val instanceof Array ? val : [val]
}

function GetRouteBasedValue(config = {}) {
  return function () {
    let selector = MakeArray(config[this.$route.name] || config['Project'])
    let value = selector.map(s => this.$path(s, this.$store.state)).find(Boolean)

    return value || config.default
  }
}

const SortByKey = key => (a, b) => {
  if (a[key] < b[key]) return -1
  if (a[key] > b[key]) return 1
  return 0
}


function getNorwegianHolidays(year, options = {}) {

  const { includeLabel = true, formateDate = true } = options
  const formatDate = (d) => {
    const date = d.toLocaleDateString('nb-NO')
    const [day, month, year] = date.split('.')
    return `${year.trim()}/${month}/${day}`
  }

  const a = year % 19,
    b = Math.floor(year / 100),
    c = year % 100,
    d = Math.floor(b / 4),
    e = b % 4,
    f = Math.floor((b + 8) / 25),
    g = Math.floor((b - f + 1) / 3),
    h = (19 * a + b - d - g + 15) % 30,
    i = Math.floor(c / 4),
    k = c % 4,
    l = (32 + 2 * e + 2 * i - h - k) % 7,
    m = Math.floor((a + 11 * h + 22 * l) / 451),
    month = Math.floor((h + l - 7 * m + 114) / 31),
    day = ((h + l - 7 * m + 114) % 31) + 1,
    easter = new Date(year, month - 1, day),
    add = (d, n) => {
      const r = new Date(d);
      r.setDate(r.getDate() + n);
      return new Date(r.getFullYear(), r.getMonth(), r.getDate());
    },
    holidays = [
      { date: new Date(year, 0, 1), label: "Nyttårsdag" },
      { date: add(easter, -3), label: "Skjærtorsdag" },
      { date: add(easter, -2), label: "Langfredag" },
      {
        date: new Date(
          easter.getFullYear(),
          easter.getMonth(),
          easter.getDate()
        ),
        label: "Første påskedag",
      },
      { date: add(easter, 1), label: "Andre påskedag" },
      { date: add(easter, 39), label: "Kristi himmelfartsdag" },
      { date: add(easter, 49), label: "Første pinsedag" },
      { date: add(easter, 50), label: "Andre pinsedag" },
      { date: new Date(year, 4, 1), label: "Arbeidernes dag" },
      { date: new Date(year, 4, 17), label: "Grunnlovsdag" },
      { date: new Date(year, 11, 25), label: "Første juledag" },
      { date: new Date(year, 11, 26), label: "Andre juledag" },


    ].map(item => {
      const date = formateDate ? formatDate(item.date) : item.date
      if (!includeLabel) return date
      return {
        ...item,
        date
      }
    })
  return holidays.sort((a, b) => a.date - b.date);
}


function GetJwtPayload(token) {
  if (!token) return null
  const parts = token.split('.')
  if (parts.length !== 3) return null
  try {
    return JSON.parse(atob(parts[1]))
  } catch (e) {
    return null
  }
}

export {
  GetRouteBasedValue,
  MakeArray,
  Clone,
  PartialUpdate,
  IconBinding,
  setByPath,
  getByPath,
  Debounce,
  isObject,
  getDimensions,
  getCookie,
  Capitalize,
  Initials,
  SortByKey,
  getNorwegianHolidays,
  GetJwtPayload
}
